export const E_TYPE: any = {
  E0: 'ALLE',
  E1: 'UNI/FH/PH',
  E2: 'Mittlere/Höhere Schulen',
  E3: 'Lehre',
  E4: 'Kurz-/Spezialausbildung',
};

export const JOBS_VERSION = 'v-4.0';
